import global from "./global.js";

const log = global.log.getLogger("f_mtac.GalleryViewer");
log.setLevel(log.levels.WARN);

var ImageViewer = function () {
    var image = $("#gallery_viewer img");
    var object_url = null;
    this.set_media_data = (media_data) => {
        object_url = window.URL.createObjectURL(media_data);
        image.attr("src", object_url);
    };
    this.show = () => {
        image.css("display", null);
    };
    this.play = () => {};
    this.reset = () => {
        image.hide();
        image.attr("src", null);
        window.URL.revokeObjectURL(object_url);
    };
};

var AudioViewer = function () {
    var audio = $("#gallery_viewer audio");
    var object_url = null;
    this.set_media_data = (media_data) => {
        object_url = window.URL.createObjectURL(media_data);
        audio.attr("src", object_url);
    };
    this.show = () => {
        audio.css("display", null);
    };
    this.play = () => {
        audio[0].play();
    };
    this.reset = () => {
        audio.hide();
        audio[0].pause();
        audio.attr("src", null);
        window.URL.revokeObjectURL(object_url);
    };
};

var VideoViewer = function () {
    var video = $("#gallery_viewer video");
    var object_url = null;
    this.set_media_data = (media_data) => {
        object_url = window.URL.createObjectURL(media_data);
        video.attr("src", object_url);
    };
    this.show = () => {
        video.css("display", null);
    };
    this.play = () => {
        video[0].play();
    };
    this.reset = () => {
        video.hide();
        video[0].pause();
        video.attr("src", null);
        window.URL.revokeObjectURL(object_url);
        object_url = null;
    };
};

var GalleryViewer = function () {
    var interaction = null;
    var viewers = {};
    var interaction_end = () => {
        // Deleted code that checked interaction state to continu, but face problem with Floater + we reset the viewer but doesn't seem to pose any problem when code removed
        $("#gallery_viewer").hide();
        interaction.resolve();
    };
    $("body").on("dblclick", "#map_area svg g.node.attachment", async (event) => {
        log.debug("GalleryViewer.dblclick ", event);
        log.debug("GalleryViewer.dblclick target ", event.target);
        log.debug("GalleryViewer.dblclick current target ", event.currentTarget);
        // On mobile, on double press, event dblclick is fired twice:
        // - once with isTrusted=True -> it comes from users
        // - once with isTrusted=False -> fired programmatically (see scene.js)
        // On PC, event dblclick is fired once with isTrusted = False
        // --> filter isTrusted = True
        if (!event.isTrusted) {
            await interact({attachment: event.currentTarget});
        }
    });
    $("body").on("click.gallery.viewer.close", "#gallery_viewer span.close", () => {
        interaction_end();
    });

    const download = ({media_data, media_name}) => {
        var object_url = window.URL.createObjectURL(media_data);
        // For other documents:
        // Create a link pointing to the ObjectURL containing the blob.
        var link = document.createElement("a");
        link.href = object_url;
        if (media_data.type === "application/pdf") {
            link.download = `${media_name}.pdf`;
        } else {
            link.download = media_name;
        }
        link.click();
        setTimeout(() => {
            // For Firefox it is necessary to delay revoking the ObjectURL
            window.URL.revokeObjectURL(object_url);
        }, 100);
    };

    this.init = function () {
        viewers.image = new ImageViewer();
        viewers.audio = new AudioViewer();
        viewers.video = new VideoViewer();
    };

    window.addEventListener("f_mtac.init", () => {
        this.init();
    });

    var interact = async ({attachment}) => {
        var media = await global.storage.selected_space.media_retrieve({
            local_id: $(attachment).data("media")
        });
        if (media === undefined) {
            return;
        }
        var media_type = media.media_data.type.split("/")[0];
        await global.scene.floaters.create(media_type, attachment);
        if (media_type in viewers) {
            interaction = {viewer: viewers[media_type]};
            interaction.viewer.set_media_data(media.media_data);
            return new Promise((resolve) => {
                interaction.resolve = resolve;
            });
        } else {
            download(media);
        }
    };
};
export default new GalleryViewer();
